/**
 * Coup de pouce, Attendu 1229 « donner la nature d'une expression
 * littérale : 3x + 2 est une somme, 5(x + 4) est un produit » (3e, Calcul
 * littéral, l. 797). Seconde passe 3e (2026-09-13). UNE page STATIQUE
 * partagée par les trois clés.
 *
 * L'image que l'élève a déjà : « la dernière opération que je ferais si
 * je calculais » (4e, priorités opératoires ; fiche 1109 « une somme : des
 * paquets, un produit : un rectangle »). 3x + 2 : je calculerais 3 × x
 * d'abord, puis + 2 en dernier : le + est la dernière opération, c'est une
 * somme. 5(x + 4) : la parenthèse d'abord, puis × 5 en dernier : c'est un
 * produit. La dernière opération est entourée en orange.
 *
 * SACRIFIÉS : 3x + 2 et 5(x + 4), toutes lettres (gen_1229,
 * gen1229.self.test.js).
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';

const ligne = (y, contenu, taille = 12, couleur = ENCRE, x = 200) => `<text x="${x}" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
const rond = (x, y, r = 13) => `<circle cx="${x}" cy="${y}" r="${r}" fill="none" stroke="${ORANGE}" stroke-width="1.8"/>`;
// La lettre x en italique et en serif, le signe × droit : dans la police de l'app les deux se
// confondaient (revue prof 2026-09-18).
const X = '<tspan font-style="italic" font-family="Georgia,serif">x</tspan>';
const mot = (y, texte, x) => `<text x="${x}" y="${y}" font-size="15" font-weight="bold" text-anchor="middle" fill="${ORANGE}">${texte}</text>`;

const SVG = svg(
    '3x plus 2 : d’abord 3 fois x, la dernière opération est le plus, entouré : c’est une somme. 5 fois x plus 4, égal à 5 facteur de x plus 4, le signe fois ne s’écrit pas devant une parenthèse : d’abord la parenthèse, la dernière opération est le fois 5, entouré : c’est un produit. La nature, c’est la dernière opération que je ferais.',
    `<!-- 1. la somme -->
  <!-- chaque morceau est posé séparément pour que le rond entoure exactement l'opérateur (revue prof 2026-09-18) -->
  ${ligne(48, `<tspan fill="${BLEU}">3${X}</tspan>`, 22, ENCRE, 86)}
  ${ligne(48, '+', 22, ENCRE, 112)}
  ${ligne(48, '2', 22, ENCRE, 138)}
  ${rond(112, 42)}
  ${ligne(74, `d’abord 3 × ${X}, <tspan fill="${ORANGE}">+ 2</tspan> en dernier`, 11, GRIS, 110)}
  ${mot(102, 'une somme', 110)}

  <!-- 2. le produit -->
  <!-- le × est écrit, alors que 5(x + 4) s'écrit sans : la ligne 3 le dit -->
  ${ligne(48, '5', 22, ENCRE, 250)}
  ${ligne(48, '×', 22, ENCRE, 276)}
  ${ligne(48, `<tspan fill="${BLEU}">(${X} + 4)</tspan>`, 22, ENCRE, 322)}
  ${rond(276, 42)}
  ${ligne(74, `d’abord (${X} + 4), <tspan fill="${ORANGE}">× 5</tspan> en dernier`, 11, GRIS, 290)}
  ${mot(102, 'un produit', 290)}
  <line x1="200" y1="24" x2="200" y2="112" stroke="${GRIS}" stroke-width="0.8" stroke-dasharray="3 3"/>
  ${ligne(128, `5 × (${X} + 4) = 5(${X} + 4) : le signe × ne s’écrit pas devant une parenthèse.`, 11, GRIS)}

  <!-- 3. le geste -->
  ${ligne(156, 'La nature, c’est la dernière opération que je ferais.', 13)}
  ${ligne(178, 'Le dernier + : une somme. Le dernier × : un produit.', 12, GRIS)}`,
    194,
);

const AIDE = { pages: [{ titre: 'La dernière opération', svg: SVG }] };

const CP_1229 = {
    nature_qcm_unique: AIDE,
    nature_tableau_vf: AIDE,
    laquelle_qcm_unique: AIDE,
};

export default CP_1229;
